import { render, staticRenderFns } from "./NSITable.vue?vue&type=template&id=73a0d3c0&"
import script from "./NSITable.vue?vue&type=script&lang=js&"
export * from "./NSITable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports